import { render } from "./TemplateManageView.vue?vue&type=template&id=2b631a1a&scoped=true"
import script from "./TemplateManageView.vue?vue&type=script&lang=js"
export * from "./TemplateManageView.vue?vue&type=script&lang=js"

import "./TemplateManageView.vue?vue&type=style&index=0&id=2b631a1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b631a1a"]])

export default __exports__